import classNames from "classnames";
import React from "react";
const Tab = ({
    isActive = false,
    text = 'default',
    onTabClick,
    onClick,
    id,
}) => {

  const finalClassName = classNames(
    "tab-item",
    {
     "tab-active": isActive,
    }
  )

  const onClickHandler = (event) => {
    onTabClick?.(id)
    onClick?.(event)
  }


  return (
    <div onClick={onClickHandler} className={finalClassName}>
      <div className="tab-text">{text}</div>
    </div>
  );
};
export default Tab;